<template>
  <Modal
    class-name="analyzing-dialog"
    :value="showDialog"
    :title="title"
    :footer-hide="true"
    width="80%"
    @on-cancel="closeDialog"
  >
    <div v-if="showAnalyzingForm" class="analyzing-container">
      <div
        :class="showBottomBtn ? 'analyzing-main' : 'analyzing-total'"
        :style="showEdit ? 'bottom: 0;' : ''"
      >
        <div class="analyzing-patient-info">
          <span class="patient-name">{{ analyzingDetail.name }}</span>
          <span class="patient-other">
            <span class="patient-other-item">{{ gender }}</span>
            <span class="patient-other-item">{{ analyzingDetail.age }}岁</span>
            <span class="patient-other-item">{{ analyzingDetail.phone }}</span>
          </span>
        </div>
        <!-- label-width="100px" -->
        <Form
          ref="recordFormRef"
          v-if="showForm"
          :model="ruleForm"
          class="analyzing-Form"
          label-position="top"
        >
          <FormItem
            class="analyzing-item medical-record"
            label="病历信息"
            :prop="ruleForm.analysisCheck ? '' : 'detail'"
          >
            <div class="medical-record-box">
              <div
                class="medical-record-content"
                v-if="analyzingDetail.detail.length > 0"
              >
                <div
                  v-for="(recordItem, index) in analyzingDetail.detail"
                  :key="index"
                >
                  <div v-if="pageIndex === index + 1">
                    <recordDetailItem
                      v-if="showDetail"
                      :recordItem="recordItem"
                    ></recordDetailItem>
                  </div>
                </div>
                <Page
                  v-if="analyzingDetail.detail.length > 0"
                  class="record-pagination"
                  :page-size="1"
                  :default-page-size="1"
                  :total="analyzingDetail.detail.length"
                  size="small"
                  layout="prev, pager, next"
                  @current-change="paginationChange"
                />
              </div>
              <div class="medical-record-none" v-else>
                没有病历信息<span v-if="showBottomBtn">，请添加病历</span>
              </div>
            </div>
          </FormItem>
          <FormItem
            class="analyzing-item medical-record"
            label="回访情况描述/患者反馈"
            prop="desc"
          >
            <div
              v-if="
                analyzingDetail.hfDetail &&
                analyzingDetail.hfDetail.includes('服药满月，定期病案分析')
              "
              class="analyzing-detail-content"
            >
              <span>{{ analyzingDetail.hfDetail }}</span>
              <span>{{ purposeOfConsultationName }}</span>
            </div>
            <div
              v-else
              class="analyzing-detail-content"
              v-html="analyzingDetail.hfDetail"
            ></div>
          </FormItem>
          <div class="analyzing-field">
            <div v-html="ruleForm.baAnalysis"></div>
          </div>
        </Form>
      </div>
    </div>
  </Modal>
</template>

<script>
import request from "@/utils/request";
import { mapGetters } from "vuex";
// import Editor from "@/components/WangEditor/index.vue";
import recordDetailItem from "./recordDetailItem.vue";
// import { useDictStore } from "@/store/modules/dict";
// import { valueToLabel } from "@/utils/cmzy";
// dictStore = useDictStore();
// import { getText, isNull } from "@/utils/tool";
// taskInfo = inject("taskInfo");
export default {
  props: {
    showBottom: {
      type: Boolean,
      default: true,
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    taskStatus: {
      type: Number,
      default: 1,
    },
    taskInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    recordDetailItem,
  },
  data() {
    return {
      showBottomBtn: false,
      showEdit: false,
      pageIndex: 1,
      showAnalyzingForm: false,
      showDetail: true,
      autoChoose: "1",
      gender: "",
      imgUrl: "http://pic.cimaizhongyi.com/Picture/analysis/",
      showForm: true,
      analyzingDetail: {
        name: "",
        age: "",
        phone: "",
        gender: "",
        detail: [],
        hfDetail: "",
        baId: 0,
        patientCode: "",
        purposeOfConsultationName: "",
        diseaseTypeName: "",
        doctorName: "",
        hospitalName: "",
        visitDate: "",
        dsNamesList: [],
        dsNamesReduce: [],
        hisDrugsVOList: [],
        sanfangDiagnosticDrugsVOList: [],
        diagnosticDrugsVOList: [],
        auditDetailVOS: [],
      },
      ruleForm: {
        baAnalysis: "",
        analysisReason: "",
        detail: [],
        analysisCheck: false,
        autoChoose: "",
      },
      startTimeRage: "",
      endTimeRage: "",
      purposeOfConsultationName: "",
    };
  },
  computed: {
    ...mapGetters(["dicts"]),
    title() {
      return "病案分析结果";
    },
  },
  watch: {
    analyzingDetail: {
      handler(val) {
        this.watchData();
      },
      deep: true,
    },
    showDialog(value) {
      if (value) this.init();
    },
  },
  methods: {
    closeDialog() {
      this.$emit("toggleHandle", { showDialog: false });
    },
    /**分页 */
    paginationChange(val) {
      this.pageIndex = val;
    },
    // 症状差异获取
    dsNameDiff(dsNames1, dsNames2) {
      return [
        dsNames1.filter((i) => dsNames2.includes(i)), //交集
        dsNames1.filter((i) => !dsNames2.includes(i)), //差集1
        dsNames2.filter((i) => !dsNames1.includes(i)), //差集2
      ];
    },

    formatDsName(index, arr) {
      let list1 = index - 1 > -1 ? arr[index - 1].symptom.split("|") : [];
      let list2 = arr[index].symptom.split("|");
      return this.dsNameDiff(list2, list1);
    },
    getData() {
      request
        .post("/saasbaihui/analysisDetail", {
          taskId: this.taskInfo.taskId,
        })
        .then((res) => {
          if (res.result) {
            if (res.result.detail && res.result.detail.length !== 0) {
              this.setDetail(res.result);
            } else {
              if (Number(res.result.isAnalysis) !== 2) {
                this.getMedicalRecords(res.result);
              } else {
                this.setDetail(res.result);
              }
            }
          }
        });
    },
    setDetail(res) {
      this.analyzingDetail = res;
      this.ruleForm.analysisReason = res.analysisReason;
      this.ruleForm.baAnalysis = res.baAnalysis;
      this.autoChoose = res.autoChoose.toString();
      if (res.isAnalysis === 2) {
        this.ruleForm.analysisCheck = true;
      } else {
        this.ruleForm.analysisCheck = false;
      }
      if (this.analyzingDetail.detail) {
        // 病历信息中的两个病历之前的增减是选中时对比的结果，不是之前病历列表保存起来的结果
        this.analyzingDetail.detail.map((i, index) => {
          let arr = this.formatDsName(index, this.analyzingDetail.detail);
          let addArr = arr[1].map((item) => {
            return {
              label: item,
              add: arr[0].length || arr[2].length ? true : false,
            };
          });
          let someArr = arr[0].map((item) => {
            return {
              label: item,
              add: false,
            };
          });

          i.dsNamesList = someArr.concat(addArr);
          i.dsNamesReduce = arr[2];
          i.show = false;
        });
      }
      // 根据字典显示性别
      let genderList = this.dicts["GENDER"];

      if (this.analyzingDetail.gender) {
        this.gender = this.common.valueToLabel(
          genderList,
          this.analyzingDetail.gender
        );
      }
      this.watchData();
      this.showAnalyzingForm = true;
    },

    getMedicalRecords(info) {
      request
        .post("/saasreport/getMedicalAnalysisList", {
          patientCode: info.patientCode,
          startDate: "",
          endDate: "",
        })
        .then((res) => {
          if (res.result && res.result.length > 0) {
            let diffResult = [];
            let resultList = [];
            res.result.map((item) => {
              if (
                item.hisDrugsVOList &&
                item.hisDrugsVOList.length !== 0 &&
                item.hisDrugsVOList[0].drugCode
              ) {
                resultList.push(item);
              }
            });
            if (resultList.length > 1) {
              let recordList = resultList.sort((a, b) => {
                return (
                  new Date(b.visitDate).getTime() -
                  new Date(a.visitDate).getTime()
                );
              });
              recordList.reduce((acc, item, index) => {
                if (index === 1) {
                  diffResult.push(acc);
                }
                let quantity;
                if (acc.hisDrugsVOList && acc.hisDrugsVOList.length !== 0) {
                  quantity = acc.hisDrugsVOList[0].quantity;
                }
                if (
                  acc.doctorPrescription &&
                  JSON.parse(acc.doctorPrescription).length !== 0
                ) {
                  quantity = JSON.parse(acc.doctorPrescription)[0].quantity;
                }
                if (
                  new Date(acc.visitDate).getTime() -
                    new Date(item.visitDate).getTime() <
                  (30 + Number(quantity)) * 24 * 60 * 60 * 1000
                ) {
                  diffResult.push(item);
                  return item;
                }
                return acc;
              });
              this.analyzingDetail.detail = diffResult.reverse();
            } else {
              this.analyzingDetail.detail = resultList;
            }
            //整理数据-生成symptom数组
            this.analyzingDetail.detail.map((i) => {
              i.symptom = i.dsVOList.map((j) => j.dsName).join("|");
              i.id = i.symptomNo;
              return i;
            });
            info.detail = this.analyzingDetail.detail;
          }
          this.setDetail(info);
        });
    },
    watchData() {
      if (
        this.analyzingDetail.detail &&
        this.analyzingDetail.detail.length > 0
      ) {
        let startItem = this.analyzingDetail.detail[0];
        let endItem =
          this.analyzingDetail.detail[this.analyzingDetail.detail.length - 1];
        this.startTimeRage = startItem.visitDate || startItem.visitDateTime;
        this.endTimeRage = endItem.visitDate || endItem.visitDateTime;
        let startPurposeName =
          startItem.purposeOfConsultationName || startItem.chiefComplaint;
        let endPurposeName =
          endItem.purposeOfConsultationName || endItem.chiefComplaint;
        if (
          startPurposeName === endPurposeName &&
          this.analyzingDetail.detail.length > 1
        ) {
          this.purposeOfConsultationName =
            "。首次和末次病历主诉未变，都是" + startPurposeName + "。";
        } else {
          this.purposeOfConsultationName = "";
        }
      }
    },

    init() {
      this.showBottomBtn = this.showBottom;
      this.$store.dispatch("getWideUseList", "GENDER");
      this.getData();
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.Page) {
  color: red;

  button {
    background-color: transparent;
  }

  li {
    background-color: transparent;
  }
}
</style>
<style lang="scss">
.analyzing-dialog {
  .operate-edit {
    position: absolute;
    right: 20px;
    top: 15px;
    z-index: 9;
  }
  .submit-records {
    float: right;
    width: 200px;
    height: calc(100vh - 100px);
    line-height: 74px;
    .submit-records-title {
      font-size: 18px;
      font-weight: bold;
      border-bottom: 1px solid #ddd;
      padding: 0 20px;
    }
    .submit-records-list {
      font-size: 16px;
      width: 100%;
      line-height: 40px;
      height: calc(100% - 30px);
      overflow: auto;
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        border-radius: 6px;
      }
      /*定义滚动条轨道内阴影+圆角*/
      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        background-color: #fff;
      }
      /*定义滑块内阴影+圆角*/
      &::-webkit-scrollbar-thumb {
        border-radius: 6px;
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
        background-color: #c8c9cc;
      }
      .record-item {
        padding: 16px;
        border-bottom: 1px solid #ddd;
        cursor: pointer;
        &.active-record {
          background-color: rgb(255, 233, 233);
        }
      }
    }
  }

  .analyzing-container {
    position: relative;
    width: 100%;
    .analyzing-total {
      width: 100%;
      padding: 36px;
    }

    .analyzing-main {
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        border-radius: 6px;
      }
      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        background-color: #fff;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 6px;
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
        background-color: #c8c9cc;
      }
    }

    .analyzing-patient-info {
      margin-bottom: 15px;

      .patient-name {
        font-size: 18px;
        font-weight: bold;
        padding-right: 15px;
      }

      .patient-other {
        margin: 16px 0;
        .patient-other-item {
          margin-right: 15px;
        }
      }
    }

    .analyzing-Form {
      .analyzing-item {
        position: relative;
        .analyzing-detail-content {
          :deep img {
            max-width: 400px;
          }
        }
        .desc-word {
          position: absolute;
          left: 64px;
          top: -35px;
          color: #000;
        }
        .add-medical-record {
          position: absolute;
          top: -36px;
          right: 0;
          padding-left: 30px;
          line-height: 32px;
          cursor: pointer;

          .record-icon {
            position: absolute;
            left: 8px;
            top: 8px;
            font-size: 16px;
          }
        }

        .medical-record-box {
          position: relative;
          width: 100%;
          padding: 24px 15px;
          background-color: #f5f7fa77;

          .medical-record-content {
            padding-bottom: 20px;
            // padding-right: 80px;

            .dBtn {
              position: absolute;
              top: 0;
              right: 0;
              color: red;
              line-height: 32px;
              cursor: pointer;
              padding: 10px 24px;

              &:hover {
                opacity: 0.6;
              }

              .del-icon {
                position: absolute;
                left: 0;
                top: 50%;
                font-size: 16px;
                margin-top: -8px;
              }
            }

            .record-pagination {
              position: absolute;
              right: 10px;
              bottom: 10px;
            }
          }

          .medical-record-none {
            text-align: center;
          }
        }

        .analyzing-editor {
          #editor-container {
            height: calc(100% - 85px) !important;
          }
          z-index: 21;
        }

        .analysis-html {
          table {
            border-collapse: collapse;

            th {
              background-color: #f5f2f0;
              font-weight: 700;
              text-align: center;
            }

            th,
            td {
              border: 1px solid #ccc;
              line-height: 1.5;
              min-width: 30px;
              padding: 3px 5px;
              text-align: left;
            }
          }
        }
      }

      .analyzing-field {
        position: relative;

        .analyzing-fail {
          position: absolute;
          right: 0;
          top: -10px;
          z-index: 2;

          .tip-info {
            vertical-align: top;
            display: inline-block;
            line-height: 40px;
          }
        }
      }
    }

    .analyzing-footer {
      position: absolute;
      width: 100%;
      bottom: 0;
      min-height: 60px;
      left: 0;
      right: 0;
      margin: auto;
      z-index: 9;
      display: flex;

      .analyzing-footer-item {
        flex: 1;
        margin: 0;
        padding: 0;
        height: 60px;
        border-radius: 0;
        background: #f1f1f1;
        font-size: 16px;

        .icon {
          margin-right: 8px;
        }

        &.analyzing-drafts {
          border-right: 1px solid #cdd0d6;
        }
      }
    }
  }
}
.feedback-content {
  padding: 10px 20px;
  max-height: 500px;
  overflow: auto;
  margin: 10px;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    border-radius: 6px;
  }
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    background-color: #fff;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 6px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    background-color: #c8c9cc;
  }
  .feedback-item {
    border-bottom: 1px solid #ccc;
    padding: 10px;
    line-height: 26px;
  }
}
</style>
